import {SidebarLinkInterface} from "@ui/modules/sidebar/sidebar-link.interface";
import {UserRoleEnum} from "@ui/directives/access/user-role.enum";

export enum SiteRouteEnum {
  PARTICIPANTS = 'participants',
  VOUCHERS = 'vouchers',
  COUPONES = 'coupones',
  MESSENGER = 'messenger',
  GOODS = 'goods',
  EVENT_LOG = 'event-log',
  INCIDENTS = 'incidents',
  RESPONSE_TEMPLATES = 'templates'
}

export const routes: SidebarLinkInterface[] = [
  {
    icon: 'supervisor_account',
    routerLink: SiteRouteEnum.PARTICIPANTS,
    label: 'Участники конкурса',
    roles: [UserRoleEnum.SYS_HI_LVL]
  },
  {
    icon: 'qr_code',
    routerLink: SiteRouteEnum.VOUCHERS,
    label: 'Чеки участников',
    roles: [UserRoleEnum.SYS_HI_LVL]
  },
  {
    icon: 'receipt',
    routerLink: SiteRouteEnum.COUPONES,
    label: 'Купоны',
    roles: [UserRoleEnum.SYS_HI_LVL]
  },
  {
    icon: 'forum',
    routerLink: SiteRouteEnum.MESSENGER,
    label: 'Чат с участниками',
    roles: [UserRoleEnum.SYS_HI_LVL, UserRoleEnum.OPERATOR]
  },
  {
    icon: 'toys',
    routerLink: SiteRouteEnum.GOODS,
    label: 'Список товаров',
    roles: [UserRoleEnum.SYS_HI_LVL]
  },
  {
    icon: 'event_note',
    routerLink: SiteRouteEnum.EVENT_LOG,
    label: 'Журнал событий',
    roles: [UserRoleEnum.SYS_HI_LVL]
  },
  {
    icon: 'restore',
    routerLink: SiteRouteEnum.INCIDENTS,
    label: 'Инциденты',
    roles: [UserRoleEnum.SYS_HI_LVL, UserRoleEnum.OPERATOR]
  },
  {
    icon: 'comment_bank',
    routerLink: SiteRouteEnum.RESPONSE_TEMPLATES,
    label: 'Шаблоны ответов',
    roles: [UserRoleEnum.SYS_HI_LVL, UserRoleEnum.OPERATOR]
  }
];
